// enable-high-contrast button footer

document.addEventListener('DOMContentLoaded', function () {

  // product page share button
  let shareButtonWrapper = document.querySelector('.parent-share');
  let sharePopupWrapper = document.querySelector('.sharing');

  if (shareButtonWrapper && sharePopupWrapper) {
    shareButtonWrapper.addEventListener('click', e => {
      e.stopPropagation();
      shareButtonWrapper.classList.toggle('active');
      sharePopupWrapper.classList.toggle('active');
    });

    document.addEventListener('click', () => {
      shareButtonWrapper.classList.remove('active');
      sharePopupWrapper.classList.remove('active');
    });
  }
  let sharingSocialShare = document.querySelector(".sharing-socialshare");
  if (sharingSocialShare) {
    sharingSocialShare.addEventListener('click', function () {
      const shareThisBtn = document.querySelector('.st-btn.st-last[data-network="sharethis"]');
      if (shareThisBtn) {
        shareThisBtn.click();
      } else {
        console.warn("ShareThis button not found");
      }
    });
  }

let highContrastToggle = document.querySelector("#enable-high-contrast");
let footerSection = document.querySelector(".footer_block-adress-with-menus");
let bodyinfo = document.querySelector("body");

// Restore state on page load
if (sessionStorage.getItem("highContrastEnabled") === "true") {
  bodyinfo.classList.add("high-contrast");
  footerSection?.classList.add("footer-checked-active");
  if (highContrastToggle) {
    highContrastToggle.checked = true;
  }
}

// Toggle change handler
if (highContrastToggle) {
  highContrastToggle.addEventListener("change", function () {
    if (this.checked) {
      bodyinfo.classList.add("high-contrast");
      footerSection?.classList.add("footer-checked-active");
      sessionStorage.setItem("highContrastEnabled", "true");
    } else {
      bodyinfo.classList.remove("high-contrast");
      footerSection?.classList.remove("footer-checked-active");
      sessionStorage.setItem("highContrastEnabled", "false");
    }
  });
}



  // Single Qty Purchase for remnanat product
  let remnantProduct = document.querySelector(".product-form__buttons.is_remnant_true");
  if (remnantProduct) {
    document.querySelector('.product-form__buttons.is_remnant_true .product-form__submit').addEventListener('click', function (e) {
      const addToCartBtn = this;
      const productId = addToCartBtn.getAttribute('data-product-id');
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const itemInCart = cart.items.find(item => item.variant_id == productId);
            if (itemInCart) {
              // console.log('Item added to cart (checked after delay)');
              addToCartBtn.disabled = true;
            } else {
              // console.log('Item still not in cart after timeout.');
            }
          })
          .catch(err => {
            console.error('Error fetching cart:', err);
          });
      }, 2000);
    });
    document.addEventListener('click', function (e) {
      const removedButton = e.target.closest('.cart-remove-button.is_remnant_true');
      if (removedButton) {
        const productId = removedButton.getAttribute('data-variant-id');
        setTimeout(() => {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const itemStillInCart = cart.items.find(item => item.variant_id == productId);
              const addToCartBtn = document.querySelector('.product-form__buttons.is_remnant_true .product-form__submit');
              if (addToCartBtn && (!itemStillInCart || !productId)) {
                addToCartBtn.disabled = false;
                // console.log('Item removed — button re-enabled');
              } else {
                // console.log('Item still in cart or no match');
              }
            })
            .catch(err => {
              console.error('Error fetching cart after remove:', err);
            });
        }, 2000);
      }
    });
  }

  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;
  const getSectionsToRender = () => {
    return cartDrawer.getSectionsToRender().map(section => section.id);
  };
  const sections_url = window.location.pathname;

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('.upsell-checkbox');
    // console.log("Checking 123 ");
    if (!checkbox) return;
    // console.log("Checking yes ");

    const variantId = checkbox.dataset.id;
    const skuElement = checkbox.dataset.sku; 
    // console.log("skuElement", skuElement);
    const sectionsToRender = getSectionsToRender();



    if (checkbox.checked) {      
      let properties = {
        SKU: skuElement
      };

const progressEl = document.querySelector('.block_drawer-progress');

if (progressEl) {
  const freeGiftMin = parseInt(progressEl.getAttribute('data_add_freegift_price'), 10);
  const cartTotal = parseInt(progressEl.getAttribute('data-cart-total'), 10);

  if (
    cartTotal >= freeGiftMin &&
    document.querySelectorAll('.freemood-item').length <= 0 &&
    checkbox.getAttribute('data-id') ===
      document
        .querySelector('.block_cart-drawer-giftproduct')
        ?.getAttribute('data-freegiftid')
  ) {
    properties._mood_tag = "true";
  }
}



      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ 
            id: variantId,
            quantity: 1, 
            properties: properties
          }],
          sections: sectionsToRender,
          sections_url: sections_url
        }) 
      })
        .then(res => res.json())
        .then(cart => {
          cartDrawer.renderContents(cart);
          setTimeout(function () {
            if (document.querySelector('.block_cart-drawer-giftproduct')) {
              addFreeGiftProduct();
            }
            moodRewars();
          }, 500);
        });

      

   

    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const item = cart.items.find(i => i.variant_id == variantId);
          if (item) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.key,
                quantity: 0,
                sections: sectionsToRender,
                sections_url: sections_url
              })
            })
              .then(res => res.json())
              .then(updatedCart => {
                cartDrawer.renderContents(updatedCart);
                setTimeout(function () {
                  if (document.querySelector('.block_cart-drawer-giftproduct')) {
                    // addFreeGiftProduct();
                  }
                  moodRewars();
                }, 500);
              });
          }
        });
    }
  });

  document.addEventListener("click", function (event) {
    // Check if the clicked element matches any of the selectors
    if (event.target.closest(".cart_recommendation .rebuy-button")) {
      var clickedElement = event.target;
      var interval = setInterval(doStuff, 100);

      function doStuff() {
        // Find the closest rebuy-widget-container
        var container = clickedElement.closest(".rebuy-widget-container");
        if (!container) {
          clearInterval(interval);
          return;
        }

        // Find the rebuy-button inside that container
        var rebuyButton = container.querySelector(".rebuy-button");
        if (rebuyButton) {
          clearInterval(interval);
          setTimeout(function () {
            if (document.querySelector('.block_cart-drawer-giftproduct')) {
              // addFreeGiftProduct();
            }
            moodRewars();
          }, 1000);
        }
      }
    }
  });


});

document.addEventListener('DOMContentLoaded', function () {
  const compareBtn = document.querySelector('.product__tocomparelist');
  if (compareBtn) {
    compareBtn.addEventListener('click', function () {
      const handle = this.dataset.handle;
      addToCompare(handle);
    });
  }
  function addToCompare(handle) {
    let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
    if (!compareList.includes(handle)) {
      compareList.push(handle);
      localStorage.setItem('compareList', JSON.stringify(compareList));
    }
  }
});
//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  if (swat) {
    // console.log("Swym scripts tags are installed on your store");
    let event = 'sw:addedtocart';
    let listener = function (e) {
      var data = e.detail.d.productData;
      console.log("YAY! Added the product to cart", data);
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.click();
        setTimeout(() => {
          const swymCloseBtn = document.querySelector('#swym-storefront-layout-close-drawer-button');
          if (swymCloseBtn) {
            swymCloseBtn.click();
          }
        }, 300)

      }

    };
    swat.evtLayer.addEventListener(event, listener);
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

if (document.querySelectorAll("#showPassword").length > 0) {
  document.getElementById('showPassword').onclick = function () {
    const showAsText = this.checked;

    // Select both password and confirm password fields
    document.querySelectorAll('input[name="customer[password]"], input[name="customer[password_confirmation]"]').forEach(function (input) {
      input.type = showAsText ? 'text' : 'password';
    });
  };
}


// document.getElementById('block_remove_account').addEventListener('click', function() {

// const SHOP = "moodfabric.myshopify.com";
// const API_TOKEN = "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";

// async function addCustomerTag(customerId, newTag) {
//   const res = await fetch(`https://${SHOP}/admin/api/2025-07/customers/${customerId}.json`, {
//     method: "PUT",
//     headers: {
//       "Content-Type": "application/json",
//       "X-Shopify-Access-Token": API_TOKEN
//     },
//     body: JSON.stringify({
//       customer: {
//         id: customerId,
//         tags: newTag // IMPORTANT: include old tags if you don’t want to overwrite them
//       }
//     })
//   });

//   const data = await res.json();
//   console.log("Customer updated:", data);
// }

// addCustomerTag("23384889491529", "arcticgrey");
// });



function openClearCartPopup() {
  document.getElementById("clearCartPopup").classList.add("open");
}
function closeClearCartPopup() {
  document.getElementById("clearCartPopup").classList.remove("open");
}
document.addEventListener("click", function (event) {
  const popup = document.getElementById("clearCartPopup");
  const popupContent = document.querySelector("#clearCartPopup .popup-content");
  if (popup.classList.contains("open") && !popupContent.contains(event.target)) {
    if (!event.target.closest("#clear-cart-btn")) {
      closeClearCartPopup();
    }
  }
});
document.querySelector(".clearcart_close-popup").addEventListener("click", function () {
  closeClearCartPopup();
});

  // collection description readmore , readless
document.addEventListener("DOMContentLoaded", function () {
  const collectionDescElement = document.getElementById("collection-description");
  if (!collectionDescElement) return; // safe (inside function)

  let wrapper = collectionDescElement.querySelector(".collection-desc-paragraphs");

  if (!wrapper) {
    const elements = collectionDescElement.querySelectorAll(":scope > :not(h1)");

    if (elements.length) {
      wrapper = document.createElement("div");
      wrapper.classList.add("collection-desc-paragraphs");

      elements.forEach(el => wrapper.appendChild(el));
      collectionDescElement.appendChild(wrapper);
    }
  }

  const readMoreBtnElement = document.getElementById("read-more-btn");
  if (!readMoreBtnElement) return;



  // 👉 IMPORTANT: wrapper execute na thay to button hide

  if (!wrapper) {

    readMoreBtnElement.style.display = "none";

    return;

  }



  // Mobile only

  if (window.innerWidth > 576) {

    readMoreBtnElement.style.display = "none";

    return;

  }

  const isOverflowing = wrapper.scrollHeight > wrapper.clientHeight;
  if (!isOverflowing) {
    readMoreBtnElement.style.display = "none";
  } else {
    let isExpanded = false;
    readMoreBtnElement.addEventListener("click", function () {
      collectionDescElement.classList.toggle("expanded");
      isExpanded = !isExpanded;
      readMoreBtnElement.textContent = isExpanded ? "Read Less" : "Read More";
    });
  }
});






